// extracted by mini-css-extract-plugin
export var btn = "cardsList-module--btn--Cbu2-";
export var headTitle = "cardsList-module--headTitle--QarTR";
export var overflow = "cardsList-module--overflow--gMtda";
export var section = "cardsList-module--section--yltK8";
export var shadow = "cardsList-module--shadow--S0bQq";
export var wrapper = "cardsList-module--wrapper--444xQ";